import { Card } from "@app/ui"

export default function App() {
  return <Card />
}
